

const LOG_LEVELS = {
    TRACE: 1,
    DEBUG: 2,
    INFO: 3,
    WARNING: 4,
    ERROR: 5,
    CRITICAL: 6,
    RISK: 7
};

let currentLogLevels: number[] = []; // Set the default log levels
let machineInfo :any = {}
let logMessage = ''
let logMessages: string[] = [];
// Function to set log levels dynamically
export const setLogLevels = (level: string,_machineInfo:any) => {
  const logLevelValue = LOG_LEVELS[level.toUpperCase() as keyof typeof LOG_LEVELS];
  if (logLevelValue) {
    // Include all log levels at or below the specified level
    currentLogLevels = Object.values(LOG_LEVELS).filter(l => l >= logLevelValue);
    machineInfo = _machineInfo;
    console.log(`Log levels set to include ${level} and higher.`);
  } else {
    // If invalid or empty, clear all log levels
    currentLogLevels = [];
    console.log("Log levels cleared. No logs will be displayed.");
  }
};

// Utility to extract file and line number from the stack trace
const getCallerInfo = () => {
    const stack = new Error().stack;
    if (!stack || currentLogLevels.length === 0) return '';
    const stackLines = stack.split('\n');
    const callerLine = stackLines[3] || stackLines[2];
    const match = callerLine.match(/\((.*):(\d+):(\d+)\)$/);
    if (match) {
        const [, file, line, column] = match;
        return `${file}:${line}:${column}`;
    }
    return callerLine.trim();
};

// Utility to get a timestamp
const getTimestamp = () => {
    return new Date().toISOString();
};

function getLogPrefix() {
  return (
    "Subcategory: sendLogToServer - Category: Frontend - " +
    "MessageID: " + (sessionStorage.getItem("message_id") ?? 0) + " - " +
    "SessionID: " + sessionStorage.getItem("session_ID") + " - " +
    "UserID: " + machineInfo.user_id + " - " +
    "ClientID: " + machineInfo.client_id + " " + getTimestamp() + " - " +
    "logger.ts"
  );
}

const setMessage = (args: any[], level: string) =>{
const callerInfo = getCallerInfo();
logMessage = `[${getTimestamp()}] [${level}] [${callerInfo}] ${JSON.stringify(args)}`;

let logServerMessage =
`${getLogPrefix()} - ${level} - STACK: ${callerInfo} - logMessage: ${JSON.stringify(args)} - `;
         logMessages.push(logServerMessage);

}

// Logging functions
export const logRisk = (...args: any[]) => {
    if (currentLogLevels.includes(LOG_LEVELS.RISK)) {
        setMessage(args, 'RISK');
        //log to server only
        //console.warn(`%c${logMessage}`, 'color: blue');
    }
};

export const logCritical = (...args: any[]) => {
    if (currentLogLevels.includes(LOG_LEVELS.CRITICAL)) {
        setMessage(args, 'CRITICAL');
        //log to server only
        //console.error(`%c${logMessage}`, 'color: magenta');
    }
};

export const logError = (...args: any[]) => {
    if (currentLogLevels.includes(LOG_LEVELS.ERROR)) {
         setMessage(args, 'ERROR');
        console.error(`%c${logMessage}`, 'color: red');
    }
};

export const logInfo = (...args: any[]) => {
    if (currentLogLevels.includes(LOG_LEVELS.INFO)) {
        setMessage(args, 'INFO');
        console.info(`%c${logMessage}`, 'color: green');
    }
};

export const logWarning = (...args: any[]) => {
    if (currentLogLevels.includes(LOG_LEVELS.WARNING)) {
         setMessage(args, 'WARNING');
        console.warn(`%c${logMessage}`, 'color: yellow');
    }
};

export const logDebug = (...args: any[]) => {
    if (currentLogLevels.includes(LOG_LEVELS.DEBUG)) {
        setMessage(args, 'DEBUG');
        console.debug(`%c${logMessage}`, 'color: cyan');
    }
};

export const logTrace = (...args: any[]) => {
    if (currentLogLevels.includes(LOG_LEVELS.TRACE)) {
        setMessage(args, 'TRACE');
        console.trace(`%c${logMessage}`, 'color: darkgrey');
    }
};


const sendLogToServer = async () => {
    if (logMessages.length === 0) return;
    const log_api_service_enabled = process.env.REACT_APP_LOG_API_SERVICE_ENABLED;
    if(log_api_service_enabled === "FALSE") return;
    const chunkSize = 50; // Adjust the chunk size as needed
    if(!machineInfo.proxy)
        machineInfo.proxy = ''
    try {
         while (logMessages.length > 0) {
            const chunk = logMessages.splice(0, chunkSize);
             const response = await fetch(`${machineInfo.proxy}/logs`, {
                 method: 'POST',
                headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'text/event-stream',
                            'Authorization': "Bearer " + machineInfo.client_token
                        }
                 ,
                 body: JSON.stringify({logMessages:chunk}),
             });

             if (!response.ok) {
                 console.warn('Failed to send log:', response.statusText);
                 break;
             }
         }
        // If all chunks are sent successfully, clear logMessages
        logMessages = [];
    } catch (error) {
        console.error('Error sending log to server:', error);
    }
};

// Set an interval to send logs every 10 seconds
setInterval(sendLogToServer, 10000);
